import * as MuiCore from '@mui/material';
import * as React from 'react';
import { fontWeights } from './styles';

const StatusListItemText: React.FC<{ status: string; bold: boolean }> = (props) => (
    <MuiCore.Typography component="span">
        <MuiCore.Box
            fontWeight={props.bold ? fontWeights.bold : fontWeights.normal}
            fontSize={14}
            whiteSpace="normal"
            textOverflow="ellipsis"
        >
            {props.status}
        </MuiCore.Box>
    </MuiCore.Typography>
);

export { StatusListItemText };
